import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import AppStoreLink from '../components/common/AppStoreLink';
import '../styles/register.css';

/**
 * The end of the customer funnel, so it carries the site chrome like every other
 * public page — it was a bare panel with no header, footer or <main> landmark,
 * which stranded the reader with no navigation at the moment they finished
 * onboarding. `ScheduleBookingPage` had the same defect and was fixed earlier.
 */
const AccountReadyPage: React.FC = () => {
  return (
    <div className="landing-shell">
      <Header />
      <main>
        <section className="register-page">
          <div className="register-shell register-shell-single">
            <div className="register-panel register-panel-form">
              <div className="register-flow-panel register-flow-panel-success">
                <div className="register-status-badge">Account Ready</div>
                <h1 className="register-form-title">Your ShiftWagon customer account is ready.</h1>
                <p className="register-form-copy">
                  You have completed registration and verification. Get the user app to book
                  deliveries and manage your trips.
                </p>

                <div className="register-flow-actions">
                  <AppStoreLink
                    className="register-submit register-submit-inline"
                    placement="account_ready"
                  />
                  <Link className="register-secondary-button" to="/login">
                    Go to login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AccountReadyPage;
